(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rk-mega-panel"] && !Shopify.designMode) return;
  try {
    /* Passar o mouse num nome da coluna destaca o cartão da mesma série no mosaico. */
  (() => {
    if (window.__rkMegaHover) return;
    window.__rkMegaHover = true;
    const set = (link, on) => {
      const panel = link.closest('.rk-mega');
      const card = panel?.querySelector(`.rk-mega__card[data-rk-mega-key="${link.dataset.rkMegaKey}"]`);
      if (card) card.toggleAttribute('data-rk-mega-hot', on);
    };
    document.addEventListener('pointerover', (e) => {
      const link = e.target instanceof Element ? e.target.closest('.rk-mega__link[data-rk-mega-key]') : null;
      if (link) set(link, true);
    });
    document.addEventListener('pointerout', (e) => {
      const link = e.target instanceof Element ? e.target.closest('.rk-mega__link[data-rk-mega-key]') : null;
      if (link) set(link, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rk-whatsapp-float"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rk-whatsapp-float')) {
    customElements.define(
      'rk-whatsapp-float',
      class extends HTMLElement {
        connectedCallback() {
          const bubble = this.querySelector('.rk-wa__bubble');
          if (!bubble || this.dataset.popup !== 'true') return;
          let dismissed = false;
          try {
            dismissed = sessionStorage.getItem('rk-wa-dismissed') === '1';
          } catch (e) {}
          if (dismissed) return;
          this.timer = setTimeout(() => (bubble.hidden = false), Number(this.dataset.delay) || 6000);
          this.querySelector('.rk-wa__close')?.addEventListener('click', () => {
            bubble.hidden = true;
            try {
              sessionStorage.setItem('rk-wa-dismissed', '1');
            } catch (e) {}
          });
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
